import { createContext, useCallback, useContext, useEffect, useState } from "react";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";

const DICTS = { en, es, fr, de };

const LangContext = createContext({ lang: "it", t: (s) => s });
export const LANGS = ["it", "en", "es", "fr", "de"];
export const LANG_LABEL = { it: "italiano", en: "inglese", es: "spagnolo", fr: "francese", de: "tedesco" };
const LOCALES = { it: "it-IT", en: "en-GB", es: "es-ES", fr: "fr-FR", de: "de-DE" };
const detect = () => {
  const saved = localStorage.getItem("ts_lang");
  if (LANGS.includes(saved)) return saved;
  const nav = (navigator.language || "it").toLowerCase().slice(0, 2);
  return LANGS.includes(nav) ? nav : "en";
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem("ts_lang", l); setLangState(l); };
  const t = useCallback((s, vars = {}) => {
    let out = lang === "it" ? s : (DICTS[lang]?.[s] ?? en[s] ?? s);
    Object.entries(vars).forEach(([k, v]) => { out = out.replaceAll(`{${k}}`, v); });
    return out;
  }, [lang]);
  const isEn = lang === "en";
  const value = {
    lang, setLang, t, locale: LOCALES[lang],
    payCurrency: isEn ? "usd" : "eur", single: isEn ? "$1" : "1 €", monthly: isEn ? "$3" : "3 €",
  };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
export const T = ({ children, ...vars }) => useLang().t(children, vars);

export const LangSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="lang-switch" className="flex rounded-full bg-white/10 p-0.5 text-xs font-bold ring-1 ring-white/25 backdrop-blur-md">
      {LANGS.map((l) => (
        <button key={l} data-testid={`lang-${l}-button`} onClick={() => setLang(l)} aria-pressed={lang === l}
          className={`rounded-full px-2.5 py-1.5 uppercase transition-colors ${lang === l ? "bg-white text-emerald-800" : "text-white/80 hover:text-white"}`}>{l}</button>
      ))}
    </div>
  );
};
